import React, { useState, useEffect, useCallback } from "react";
import { Input } from "@nextui-org/input";
import { onKeyDown } from "../../utils/onKeyDownFunction";
import {
  validateAngleEqualLength,
  validateAngleEqualQuantity,
  validateAngleEqualThickness,
  validateAngleEqualWidth,
} from "../../utils/validateEachType";
import { onChangeInput } from "../../utils/onChangeInput.ts";
import messages from "../../errorTypes/Types.ts";

const KatownikiRownoramienne = ({ density, onWeightChange }) => {
  const [x, setX] = useState("");
  const [zBox, setZBox] = useState("");
  const [length, setLength] = useState("");
  const [count, setCount] = useState(1);

  const [errorX, setErrorX] = useState(null);
  const [errorZBox, setErrorZBox] = useState(null);
  const [errorLength, setErrorLength] = useState(null);
  const [errorCount, setErrorCount] = useState(null);

  const calculateWeight = useCallback(() => {
    const x_m = Number(x) / 1000; // mm -> m
    const zBox_m = Number(zBox) / 1000; // mm -> m
    const length_m = Number(length) / 1000; //  mm -> m
    const density_kg_m3 = density * 1000; // kg/m^3

    const volume = 2 * (x_m * zBox_m * length_m) - zBox_m * zBox_m * length_m; //m^3 substraction

    const weight = volume * density_kg_m3 * Number(count); // mass in kg
    const weightPerMeter = weight / length_m; // mass of 1m in kg
    onWeightChange({
      totalWeight: weight.toFixed(3),
      totalWeightPerKg: weightPerMeter.toFixed(3),
    });
  }, [x, zBox, length, count, density, onWeightChange]);

  useEffect(() => {
    const handler = setTimeout(() => {
      calculateWeight();
    }, 100); // Opóźnienie 100ms

    return () => {
      clearTimeout(handler);
    };
  }, [calculateWeight]);

  return (
    <div className="obliczenia">
      <div className="obliczenia-inputs">
        <label htmlFor="x-input">[A] Wpisz szerokość (mm)</label>
        <Input
          id="x-input"
          type="text"
          autoComplete="off"
          value={x}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setX,
              validateAngleEqualWidth,
              4,
              2,
              setErrorX,
              messages.rownoramienne.width
            );
          }}
          onBlur={() => {
            if (!validateAngleEqualWidth(x)) {
              setErrorX("Niepoprawny format szerokości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setX)}
        />
        {errorX && <p className="text-error-text">{errorX}</p>}
      </div>
      <div className="obliczenia-inputs">
        <label htmlFor="zBox-input">[B] Wpisz grubość ścianki (mm)</label>
        <Input
          id="zBox-input"
          type="text"
          autoComplete="off"
          value={zBox}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setZBox,
              validateAngleEqualThickness,
              2,
              2,
              setErrorZBox,
              messages.rownoramienne.thickness
            );
          }}
          onBlur={() => {
            if (!validateAngleEqualThickness(zBox)) {
              setErrorZBox("Niepoprawny format grubości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setZBox)}
        />
        {errorZBox && <p className="text-error-text">{errorZBox}</p>}
      </div>
      <div className="obliczenia-inputs">
        <label htmlFor="length-input">[C] Wpisz długość kątownika (mm)</label>
        <Input
          id="length-input"
          type="text"
          autoComplete="off"
          value={length}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setLength,
              validateAngleEqualLength,
              5,
              2,
              setErrorLength,
              messages.rownoramienne.length
            );
          }}
          onBlur={() => {
            if (!validateAngleEqualLength(length)) {
              setErrorLength("Niepoprawny format długości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setLength)}
        />
        {errorLength && <p className="text-error-text">{errorLength}</p>}
      </div>
      <div className="obliczenia-inputs">
        <label htmlFor="count-input">Wpisz ilość (szt.)</label>
        <Input
          id="count-input"
          type="text"
          autoComplete="off"
          value={count}
          classNames={{
            inputWrapper:
              "bg-transparent rounded-none group-data-[focus=true]:bg-transparent data-[hover=true]:bg-transparent px-0",
            input: "h-9",
          }}
          onChange={(e) => {
            onChangeInput(
              e,
              setCount,
              validateAngleEqualQuantity,
              5,
              0,
              setErrorCount,
              messages.rownoramienne.quantity
            );
          }}
          onBlur={() => {
            if (!validateAngleEqualQuantity(count)) {
              setErrorCount("Niepoprawny format ilości");
              return;
            }
          }}
          onKeyDown={(e) => onKeyDown(e, setCount)}
        />
        {errorCount && <p className="text-error-text">{errorCount}</p>}
      </div>
    </div>
  );
};

export default KatownikiRownoramienne;
